import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

// ANT DESIGN IMPORTS
import {
  Button,
  Card,
  Col,
  Descriptions,
  Divider,
  Row,
  Spin,
  Table,
  Typography,
  Form,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../security.config";
import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";

const { Text } = Typography;

const DetailAuditTrails = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [form] = Form.useForm();

  const [auditTrailList, setAuditTrailList] = useState({});
  const [commandRows, setCommandRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getAuditDetailById();
  }, []);

  const getAuditDetailById = () => {
    const url = `${apiConfig.Audits}/${state.id}`;
    const body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setAuditTrailList(res);
        const commands = res?.commandAsJson;
        let commandData = {};
        if (commands) {
          if (typeof commands === "string") {
            try {
              commandData = JSON.parse(commands);
            } catch (err) {
              console.error("Error parsing commands:", err);
            }
          } else if (typeof commands === "object") {
            commandData = commands;
          }
          const rows = Object.entries(commandData).map(([key, value], index) =>
            // console.log(value),
            ({
              key: index.toString(),
              command: key,
              // value: value,
              value:
                value !== undefined && value !== null
                  ? typeof value === "object"
                    ? JSON.stringify(value)
                    : String(value)
                  : "",
            })
          );
          setCommandRows(rows);
        }
      }
      setIsLoading(false);
    });
  };

  const columns = [
    {
      title: "Command",
      dataIndex: "command",
    },
    {
      title: "Value",
      dataIndex: "value",
    },
  ];

  const items = [
    {
      label: auditTrailList.id ? "ID" : null,
      children: auditTrailList ? auditTrailList.id : "-",
    },
    {
      label: auditTrailList.processingResult ? "Status" : null,
      children: auditTrailList ? auditTrailList.processingResult : "-",
    },
    {
      label: auditTrailList.maker ? "User" : null,
      children: auditTrailList ? auditTrailList.maker : "-",
    },
    {
      label: auditTrailList.actionName ? "Action" : null,
      children: auditTrailList ? auditTrailList.actionName : "-",
    },
    {
      label: auditTrailList.entityName ? "Entity" : null,
      children: auditTrailList ? auditTrailList.entityName : "-",
    },
    {
      label: auditTrailList.resourceId ? "User IP" : null,
      children: auditTrailList ? auditTrailList.clientIp : "-",
    },
    {
      label: auditTrailList.resourceId ? "Timestamp" : null,
      children: auditTrailList
        ? BOM.DateTime(auditTrailList?.madeOnDate, "with-seconds")
        : "-",
    },
    {
      label: auditTrailList.resourceId ? "Resource ID" : null,
      children: auditTrailList ? auditTrailList.resourceId : "-",
    },
    {
      label: auditTrailList.officeName ? "Office" : null,
      children: auditTrailList ? auditTrailList.officeName : "-",
    },
    {
      label: auditTrailList.groupName ? "Group" : null,
      children: auditTrailList ? auditTrailList.groupName : "-",
    },
    {
      label: auditTrailList.madeOnDate ? "Date" : null,
      children: auditTrailList
        ? BOM.DateTime(auditTrailList.madeOnDate, "only-date")
        : "-",
    },
    {
      label: auditTrailList.loanAccountNo ? "Loan Account" : null,
      children: auditTrailList ? auditTrailList.loanAccountNo : "-",
    },
    {
      label: auditTrailList.savingsAccountNo ? "Savings Account" : null,
      children: auditTrailList ? auditTrailList.savingsAccountNo : "-",
    },
  ];

  const backOnClick = () => {
    navigate("/sms0500", { state });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.detailAuditTrails}
        pageItems={staticConfig.detailAuditTrailBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row style={{ alignContent: "center" }}>
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{ marginTop: "auto", marginBottom: "auto" }}
                onClick={backOnClick}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Row>
            <Col span={24}>
              <Descriptions
                bordered
                column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
                style={{ marginTop: 10, marginBottom: 20 }}
                items={items}
              />
            </Col>
          </Row>
          <Divider />

          <Table
            columns={columns}
            dataSource={commandRows}
            pagination={false}
          />
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps)(DetailAuditTrails);
